import React, { Component, useLayoutEffect, useEffect, useState, useRef} from "react";
import moment from 'moment';
import CalenderHelperClass from '@/helpers/CalenderHelper'
import store from "@/redux/store";
import {setDragItem} from '@/reducers/CommunicationCycle';
import { LockClosedIcon } from '@heroicons/react/20/solid'

interface IMyProps {
    item: any,
    className?:string,
    dragOverClass?:string,
    draggable?: boolean,
    onClick?: Function,
    onDragStart?: React.DragEventHandler<HTMLDivElement>,
    onDragEnd?: React.DragEventHandler<HTMLDivElement>,
    onDrag?: React.DragEventHandler<HTMLDivElement>,
    onDrop?: React.DragEventHandler<HTMLDivElement>,
    dragElement?: any,
    onMouseEnter?: Function,
    onMouseLeave?: Function,
    saveItemHandler?:Function,
    onEventItemClickEvent:Function
    mouse?: any
    
}

class EventItem extends Component<IMyProps, any> {
//    static defaultProps: IMyProps;
//    static dragElement: any;
//    static clone: any;
mouse = {x:0, y:0};
    constructor(props) {
        super(props)
        this.onDragStartHandler = this.onDragStartHandler.bind(this);
        this.onDragEndHandler = this.onDragEndHandler.bind(this);
        this.onDragHandler = this.onDragHandler.bind(this);
        //this.onDropHandler = this.onDropHandler.bind(this);
let defaultProps:any = {item:{},
 className: '',
 dragOverClass: '',
 draggable: false,
    onClick: () => null,
    onDragStart: this.onDragStartHandler,
    onDragEnd:  this.onDragEndHandler,
    onDrag:  this.onDragHandler,
//    onDrop:  this.onDropHandler,
    dragElement: null,
    onMouseEnter: () => null,
    onMouseLeave: () => null,
    saveItemHandler: () => null
 }        
        this.state = {canwedrop: false,clone: null, props: {...defaultProps, ...props}}
        return this;
    }
    onDragHandler(event) {
        }
        
    onDragEndHandler(event) {
            let cloneElement = document.getElementById("clone");
            if(cloneElement) {
                cloneElement.remove();
            }
        let dragOverElement = store.getState().CommunicationCycleReducer.dragOverElement;
        if(!dragOverElement) return;
        const {saveItemHandler, item} = this.state.props;
        //event.preventDefault();
        let {clone, canwedrop} = this.state;
        //if(canwedrop) {
        const dayPanel = document.getElementById("days");
        let selectedkey = dragOverElement.day.key;
        const selectedPanel = document.getElementById(selectedkey);
        
        if(selectedPanel) {
        //selectedPanel.remove();
        }
        if(selectedPanel && item.dayKey && item.dayKey != selectedkey) {
            let selecteddaykey = selectedPanel.dataset.daykey;
            
            let dragDay = moment(item.dayKey, "YYYYMMDD");
            let dropElementDate = moment(selecteddaykey, "YYYYMMDD");
            let dayDiff = dropElementDate.diff(dragDay, 'days');
            let start_at = moment(item.start_at);
            let end_at = moment(item.end_at);
            //start_at->
                start_at.add(dayDiff, 'days');
                end_at.add(dayDiff, 'days');
                
                let newItem = {...item};
                newItem.start_at = start_at.valueOf();
                newItem.end_at = end_at.valueOf();
                 
                saveItemHandler(newItem);    

            delete dayPanel.dataset.selectedkey;
            selectedPanel.removeAttribute(CalenderHelperClass.onDragHoverClassName);
            store.dispatch( setDragItem(null) );
        }
        //this.setState({dragOverElementId: null});
        //localStorage.setItem("refreshView", 'calender');

        
        //let dayDiff = dropElementDate.diff(currentDay, 'days');
        
        
        //}
        
    }    

    onDragStartHandler(event) {
        
        const {item} = this.state.props;
        
        if(!CalenderHelperClass.canEdit(item)) {
            event.preventDefault();
            return false;
        }
        
        
        
        let dragItem = event.target;
        let isHistory = dragItem.getAttribute('history');
        if(!isHistory || isHistory == "0") {
         this.setState({canwedrop:false,clone: event.target.cloneNode()});
         
         dragItem = event.target.cloneNode(true);
        //event.dataTransfer.setData("text/plain", event.target.id);
        //event.dataTransfer.effectAllowed = "move";
        
        const parentElement = event.target.parentElement;
        
        //parentElement.replaceChild(dragItem, event.target);
        
        dragItem.style.position = 'absolute';
        dragItem.style.background = 'red';
        dragItem.style.zIndex = 9999;
        dragItem.style.width = "100px";
        
        
//            const dayPanel = document.getElementById("days");
//        dayPanel.appendChild(dragItem);
        
          store.dispatch( setDragItem({item:item, element:dragItem}) );

          
        } else {
            //event.preventDefault();
            //return false;
        }
     };

    onDropHandler(event) {
        //event.target.appendChild(CalenderItem.dragElement);
    };
    
    
    render() {
        const {draggable, item, className, onDragStart, onDragEnd, onDrop,onEventItemClickEvent} = this.state.props;

        let start_date = moment.unix(item.start_at);        
        let end_date = moment.unix(item.end_at);
        if((item?.modelname != 'DossierCalenderModel')) {
            start_date = moment(item.start_at);
            end_date =  moment(item.end_at);
        }
        ///moment(item.end_at).format("HH:mm") 
        
        
//        console.debug("AGENDA... ITEM", moment(item.start_at));
        
        return (
            <div draggable={draggable} 
            className={className+" "+((item?.type) ? "eventtype_"+item.type : "")+" "+(!CalenderHelperClass.canEdit(item) ? "locked" : "")} 
            onDragStart={(event) => this.onDragStartHandler(event)}
            onDrag={(event) => this.onDragHandler(event)} 
            onDrop={(event) => this.onDropHandler(event)}
            onDragEnd={(event) => this.onDragEndHandler(event)} 
            onClick={(event)=> onEventItemClickEvent(event,item)}
            >
            <span className="line"></span>    
            <div className={"contentPanel"+ ((!CalenderHelperClass.canEdit(item))? " locked" : "")}>
            {!CalenderHelperClass.canEdit(item) &&
                <LockClosedIcon className="eventLocked"/>
                }
            <span className="lblPanel">
            {(item) ? item.name : "?"} 
            </span>
            {(item?.modelname != 'DossierCalenderModel') && 
            <span className="timePanel right">{start_date.format("HH:mm")} {end_date.format("HH:mm")}</span>
            }
            </div>
            </div>
        )
        
    }
}



export default EventItem; 
